/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { ProfileTabs } from "src/components/Profile/types";

interface Props {
  tabs: { label: string; slug: ProfileTabs }[];
  selected: ProfileTabs;
  setSelected: (x: ProfileTabs) => void;
}
export function ViennaPill({ tabs, selected, setSelected }: Props) {
  return (
    <PillWrapper>
      {tabs.map(({ label, slug }) => (
        <PillItem isSelected={selected === slug} onClick={() => setSelected(slug)} key={slug}>
          {label}
        </PillItem>
      ))}
    </PillWrapper>
  );
}

const PillWrapper = styled.div`
  display: flex;
  height: 25px;
  justify-content: center;
  cursor: pointer;
`;

interface PIProps {
  isSelected: boolean;
}
const PillItem = styled.div<PIProps>`
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  line-height: 20px;
  height: 100%;
  padding: 0 26px 0 26px;
  border: ${({ theme }) => `1px solid ${theme.primary}`};
  display: flex;
  align-items: center;
  user-select: none;
  background-color: ${({ isSelected, theme }) => (isSelected ? theme.primary : theme.background)};
  color: ${({ isSelected, theme }) => (isSelected ? theme.background : theme.text.default)};
  :first-of-type {
    border-right-width: 0px;
  }
  :last-of-type {
    border-left-width: 0px;
  }
  :hover {
    background-color: ${({ isSelected }) => !isSelected && "rgba(55, 53, 47, 0.078);"};
  }
`;
